export const BUDGETS_LIST_DEFAULT_PAGE_SIZE = 10;

